if ( ! Modernizr.objectfit ) {
    $('.component_section_featured_component .col-md-4 p:first-child').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
            $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
        }
    });
}